<template>
    <div>

        <footer id="footer" class="white s3-bg">
            <div class="container">
                <div class="col-md-9 alignl">
                    <ul id="baselinks" class="list-unstyled">
                        <li>
<!--                            <h4>Product</h4>-->
                            <ul>
<!--                                <li><router-link to="/features">Features</router-link></li>-->
                              <li><router-link to="/">Home</router-link></li>
<!--                              <li><router-link to="/features">Features</router-link></li>-->
                              <li><hr style="margin:0;"/></li>
<!--                              <li><router-link to="/docker">Docker</router-link></li>-->
<!--                              <li><router-link to="#">AWS (coming soon)</router-link></li>-->
<!--                              <li><router-link to="#">Google Cloud (coming soon)</router-link></li>-->
<!--                              <li><router-link to="#">Azure (coming soon)</router-link></li>-->
                              <li><a href="https://docs.skippr.io">Docs</a></li>
                              <li><a href="/terms">Terms</a></li>
                              <li><a href="/terms/privacy">Privacy</a></li>
<!--                                <li><router-link to="/pricing">Pricing</router-link></li>-->
<!--                                <li><router-link to="/on-prem">On-Prem</router-link></li>-->
<!--                                <li><router-link to="/private-aws">AWS</router-link></li>-->
<!--                                <li><router-link to="/private-aws">Google Cloud</router-link></li>-->
<!--                                <li><router-link to="/private-azure">Azure</router-link></li>-->
                            </ul>
<!--                        </li>-->
<!--                        <li>-->
<!--                            <h4>Solutions</h4>-->
<!--                            <ul>-->
<!--                              <li><router-link to="/datalakes">Datalakes</router-link></li>-->
<!--                              <li><router-link to="/elt-cdc">ELT &amp; CDC</router-link></li>-->
<!--                              <li><router-link to="/event-sourcing">Event Sourcing</router-link></li>-->
<!--                              <li><router-link to="/sass-data-integration">SaaS Data Integration</router-link></li>-->
<!--                            </ul>-->
<!--                        </li>-->
<!--                        <li>-->
<!--                            <h4>Integrations</h4>-->
<!--                            <ul>-->
<!--                              <li><router-link to="/snowflake-skippr">Snowflake</router-link></li>-->
<!--                              <li><router-link to="/athena-skippr">Athena</router-link></li>-->
<!--                              <li><router-link to="/dbt-skippr">DBT</router-link></li>-->
<!--                              <li><router-link to="/deltalake-skippr">Delta Lake</router-link></li>-->
<!--                              <li><router-link to="/apache-arrow-skippr">Apache Arrow</router-link></li>-->
<!--                            </ul>-->
                        </li>
                    </ul>

                    <div id="legal">
                        <span class="icon-logo"></span>
                        <ul class="list-unstyled">
                            <li class="copy">© 2020 Skippr</li>
                            <li><router-link to="/terms">Terms &amp; Conditions</router-link></li>
                            <li><router-link to="/privacy">Privacy Policy</router-link></li>
<!--                            <li>Icons made by <a href="https://www.flaticon.com"> Freepik</a></li>-->
                        </ul>

                    </div>
                </div>

                <!--<div class="col-md-3">-->
                    <!--<div class="share-buttons r">-->
                        <!--<ul class="list-unstyled">-->
                            <!--<li data-network="facebook" title="Share on Facebook">-->
                                <!--<span class="sr-only">Facebook</span>-->
                                <!--<img class="svg" src="/sites/all/themes/responsive/images/facebook.png" data-svg="/sites/all/themes/responsive/images/svg/facebook.svg">-->
                            <!--</li>-->
                            <!--<li data-network="twitter" title="Share on Twitter">-->
                                <!--<span class="sr-only">Twitter</span>-->
                                <!--<img class="svg" src="/sites/all/themes/responsive/images/twitter.png" data-svg="/sites/all/themes/responsive/images/svg/twitter.svg">-->
                            <!--</li>-->
                            <!--<li data-network="gplus" title="Share on Google+">-->
                                <!--<span class="sr-only">Google+</span>-->
                                <!--<img class="svg" src="/sites/all/themes/responsive/images/googleplus.png" data-svg="/sites/all/themes/responsive/images/svg/googleplus.svg">-->
                            <!--</li>-->
                        <!--</ul>-->
                    <!--</div>-->
                <!--</div>-->
            </div>
        </footer>

    </div>
</template>

<script>
    export default {
        name: 'FooterBase',
        props: {
            msg: String
        }
    }


</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
